import { useCurrentEditor, useEditorState } from "@tiptap/react";
import type { FC } from "react";

import { EditorButton, type EditorButtonProps } from "./editor-button";

export const EditorButtonCodeBlock: FC<EditorButtonProps> = (props) => {
  const { editor } = useCurrentEditor();
  const editorState = useEditorState({
    editor,
    selector: (ctx) => ({
      isCodeBlock: ctx.editor?.isActive("codeBlock") || false,
      canToggleCodeBlock: ctx.editor?.can().chain().toggleCodeBlock().run() ?? false,
    }),
  });

  if (!editor || !editorState) {
    return null;
  }

  return (
    <EditorButton
      {...props}
      onClick={() => editor.chain().focus().toggleCodeBlock().run()}
      active={editorState.isCodeBlock}
      disabled={!editorState.canToggleCodeBlock}
      icon="code_blocks"
      tooltip="Code block"
    />
  );
};
